export class MailRuTracker {
    constructor() {
        this.init();
    }

    init() {
        window._tmr = window._tmr || [];
        return window._tmr;
    }

    push(query) {
        window._tmr.push(query);
    }

    indexPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {pagetype: 'home' }));
    }

    otherPageView() {
        this.push(this.getQueryTemplate());
    }

    categoryPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'category',
            productid: '',
            totalvalue: ''
        }));
    }

    basketPageView(ids, totalPrice) {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'cart',
            productid: ids,
            totalvalue: totalPrice,
        }));
    }

    productPageView(id, price) {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'product',
            productid: id,
            totalvalue: parseFloat(price),
        }));
    }

    orderPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'purchase'
        }));
    }

    searchPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'searchresults'
        }));
    }

    getQueryTemplate() {
        return {
            id : '3241057',
            type: 'itemView',
            productid: '',
            pagetype: 'other',
            totalvalue: '',
            list: '3'
        }
    }
}


// WEBPACK FOOTER //
// ./blocks/tracker/mailru.js